module.exports = __webpack_public_path__ + "static/img/c-music.d4b15a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c-music.png
// module id = y91l
// module chunks = 1